import * as React from 'react';
import Modal from '../../layout/modal/Modal';
import ModalHeader from '../../layout/modal/ModalHeader';
import { css } from '@emotion/core';
import { onMobileDevice } from '../../globalStyle/mediaQueries';
import { useMsgText } from '../../localization/hooks';
import { Str } from '../../localization/translationKeys';
import EmailGoalsForm from './EmailGoalsForm';
import LocalDiv from '../../localization/LocalDiv';


const styles = {
  root:             css`
    ${onMobileDevice} {
      width: 100vw;
      height: 100vh;
      margin: 0;
    }
  `,
  form:             css`
    margin: 20px;
  `,
};


type Props = {
  className?: string;
  languageId: number;
  allAnswered: boolean;
  dismiss: () => void;
};


/**
 * SendGoalsEmailModal: a component allows user to send goals email
 *
 
 * PureComponent: true
 * Redux Connected: false
 */
const SendGoalsEmailModal: React.FC<Props> = props => {
  const title     = useMsgText(Str.EmailGoals);

  return (
    <Modal css={styles.root} className={props.className} onDismiss={props.dismiss}>
      <ModalHeader title={title} onDismiss={props.dismiss} />
        <LocalDiv css={styles.form}>
          <EmailGoalsForm
            languageId={props.languageId}
            allAnswered={props.allAnswered}
          />
        </LocalDiv>
    </Modal>
  );
};

export default SendGoalsEmailModal;
